import styled from "styled-components";

export const Container = styled.div`
  background-color: #fff;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);

  border-radius: 6px;
  padding: 1rem 1rem 1rem 1rem;

  max-width: 1220px;

  .span-alert {
    font-weight: 400;
    font-size: 12px;

    a {
      color: #d21e26;
      font-weight: 700;

      &:hover {
        text-decoration: underline !important;
      }
    }
  }
`;

export const Heading = styled.h2`
  font-size: 1.2rem;
  margin-bottom: 0.875rem;
  display: flex;
  align-items: center;
`;

export const Group = styled.div`
  display: flex;
  justify-content: space-between;

  gap: 1rem;
  margin-bottom: 1rem;
`;

export const Title = styled.p`
  font-size: 1rem;
  font-weight: 500;
`;

export const Text = styled.p`
  font-size: 0.875rem;
  color: #555;
  line-height: 1.5rem;
  font-weight: 400;
`;
